import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import DomainIcon from "@mui/icons-material/Domain";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import ScaleIcon from "@mui/icons-material/Scale";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import {
  default as CustomSelect,
  default as Select,
} from "../../../components/Select/Select";
import {
  getAppointmentHistoriesByPetId,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
  getBillingsByCustomerIdForApntBook,
  getClinicVetsUnavailabilityWoLoader,
  getUserDetailsById,
} from "../../../redux/reducers/clinicSlice";
import {
  getVetHolidaysById,
  storeVetHolidaysById,
  updateVetHolidaysById,
} from "../../../redux/reducers/doctorSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import {
  createDiagnosticsWoLoader,
  createProcedureWoLoader,
  getClinicPetsForBooking,
  getPetDetailsById,
  petAppointment,
} from "../../../redux/reducers/petSlice";
import { AppColors } from "../../../util/AppColors";
import {
  eyeBtn,
  w15h15BlueIcon,
  w25h25BlueIcon,
} from "../../../util/CommonIconStyle";
import {
  appointmentLaterList,
  appointmentList,
  doneAtList,
  oldIssueList,
  serviceTypes,
  serviceTypeWOSurgery,
  typeAppointemnt,
  typeList,
  typeListNew,
  visitTypes,
} from "../../../util/dropList";
import {
  adjustTime,
  getAllDatesFromArray,
  getAllSelectedSlots,
  getAvailableBayAtTime,
  getOnlyAvailableSlots,
  getProcedureDetails,
  getRequiredSlotList,
  getRightSaluation,
  getUpcoming60Dates,
} from "../../../util/function";
import { getPetAgeDisplay } from "../../../util/getAge";
import { patchMandateSession } from "../../../util/mandateSessionStorage";
import CreateClinicPet from "../../CommonComponents/CreateClinicPet";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const getTomorrowDate = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};

const resolveInternalStartTime = (date, startTime) => {
  const resolvedDate = date ? new Date(date) : new Date();
  if (!startTime) return resolvedDate;

  if (startTime instanceof Date && !Number.isNaN(startTime.getTime())) {
    const result = new Date(resolvedDate);
    result.setHours(
      startTime.getHours(),
      startTime.getMinutes(),
      startTime.getSeconds(),
      0,
    );
    return result;
  }

  if (typeof startTime === "string") {
    const parsed = moment(
      startTime,
      [moment.ISO_8601, "HH:mm", "HH:mm:ss"],
      true,
    );
    const result = new Date(resolvedDate);
    if (parsed.isValid()) {
      result.setHours(parsed.hours(), parsed.minutes(), 0, 0);
      return result;
    }
  }

  const parsedDate = new Date(startTime);
  return Number.isNaN(parsedDate.getTime()) ? resolvedDate : parsedDate;
};

const resolveInternalEndTime = (startTimeDate, slotSize = 15) => {
  const end = new Date(startTimeDate);
  end.setMinutes(end.getMinutes() + (slotSize || 15));
  return end;
};

const getInitValues = () => ({
  bookingType: "Walk-in",
  consultationMode: "Physical",
  serviceType: { name: "Consultation", value: "Consultation" },
  visitType: { name: "New", value: "New" },
  reason: [],
  vetName: null,
  appointmentOption: "Immediate",
  date: new Date(),
  referenceCase: null,
  serviceName: [],
  remarks: "",
  facility: null,
  petSearch: "",
  assignedUsers: [],
});
const initErrors = {};
const initTimeObj = { times: [], ids: [] };
const defObj = {
  dataSharing: {},
  clinic: {},
  services: [],
  stocks: [],
  facilities: [],
  clinicHolidays: [],
  inpatients: [],
  vets: [],
};

const VetBookAnAppointment = ({
  modalVisible,
  setBookModVisible,
  selectedVet,
  handleCloseMod = () => {},
  addExtraOption = false,
  slotSize = 15,
  defaultType = "appointment",
  initialInternalValues = null,
  editUnavailabilityId = null,
}) => {
  const dispatch = useDispatch();
  const prevModalVisibleRef = useRef(false);
  const [type, setType] = useState("appointment");
  const [modOpen, setModOpen] = useState(false);
  const [petValues, setPetValues] = useState(getInitValues);
  const [petErrors, setPetErrors] = useState(initErrors);
  const [selectTime, setSelectTime] = useState(null);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [holidayDates, setHolidayDates] = useState([]);
  const [selectedPet, setSelectedPet] = useState(null);
  const [timeObject, setTimeObject] = useState(initTimeObj);
  const [previewModVsble, setPreviewModVsble] = useState(false);
  const [createPetModVsble, setCreatePetModVsble] = useState(false);
  const [internalValues, setInternalValues] = useState({});
  const [bookingSearchPets, setBookingSearchPets] = useState([]);
  const petSearchReqIdRef = useRef(0);
  const {
    userDetails,
    vetAvailability,
    vetBookedApnts,
    petApntHistories,
    // facilities,
    cutomerBillingApnt,
  } = useSelector((state) => state?.clinic);
  const petDetails = useSelector((state) => state?.pet?.petDetails);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    dataSharing: branchesDataSharing,
    clinic: clinicDet,
    services,
    stocks: clinicStocks,
    clinicHolidays,
    inpatients,
    vets: clinicVets,
    facilities,
  } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        dataSharing: reqData?.dataSharing ?? {},
        clinic: reqData?.clinic ?? {},
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        clinicHolidays: Array.isArray(reqData?.clinicHolidays)
          ? reqData?.clinicHolidays
          : [],
        inpatients: Array.isArray(reqData?.inpatients)
          ? reqData?.inpatients
          : [],
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  // useEffect(() => {
  //   dispatch(getClinicFacilities());
  // }, []);

  useEffect(() => {
    setModOpen(modalVisible);
    const justOpened = modalVisible && !prevModalVisibleRef.current;
    const justClosed = !modalVisible && prevModalVisibleRef.current;
    prevModalVisibleRef.current = modalVisible;

    // Only initialize type when the modal opens/closes — avoid resetting
    // after the user switches to Internal Use while selectedVet etc. update.
    if (justOpened) {
      if (defaultType === "internalUse") {
        setType("internalUse");
        const resolvedStartTime = resolveInternalStartTime(
          initialInternalValues?.date ?? selectedVet?.date,
          initialInternalValues?.startTime ?? selectedVet?.startTime,
        );
        const resolvedSlotSize = slotSize || 15;
        setInternalValues(
          initialInternalValues ?? {
            titleError: false,
            title: "",
            date: selectedVet?.date ?? new Date(),
            startTime: resolvedStartTime,
            endTime: resolveInternalEndTime(
              resolvedStartTime,
              resolvedSlotSize,
            ),
            remarks: "",
            users: [],
          },
        );
      } else {
        setType("appointment");
        setPetValues((prev) => ({
          ...prev,
          date: new Date(),
        }));
      }
    } else if (justClosed) {
      setType("appointment");
      setInternalValues({});
    }
  }, [modalVisible, defaultType, initialInternalValues, selectedVet, slotSize]);

  useEffect(() => {
    const vetName = selectedVet?.doctorId
      ? {
          name: selectedVet?.name,
          value: selectedVet?.doctorId,
          id: selectedVet?.doctorId,
        }
      : null;
    const facMat = facilities?.find(
      (fl) => fl?.facilityId === selectedVet?.facility,
    );
    const facility =
      selectedVet?.facility && facMat
        ? {
            name: facMat?.name,
            value: facMat?.facilityId ?? selectedVet?.facility,
            id: facMat?.facilityId ?? selectedVet?.facility,
          }
        : selectedVet?.facility
          ? {
              name: selectedVet?.facilityName ?? "",
              value: selectedVet?.facility,
              id: selectedVet?.facility,
            }
          : null;
    setPetValues((prev) => ({
      ...prev,
      // Facility booking: keep user-selected vet; don't reset on parent re-renders
      ...(vetName
        ? { vetName }
        : selectedVet?.facility
          ? {}
          : { vetName: null }),
      ...(facility ? { facility } : {}),
    }));
  }, [
    selectedVet?.doctorId,
    selectedVet?.name,
    selectedVet?.facility,
    facilities,
  ]);

  useEffect(() => {
    const vetId = petValues?.vetName?.value;
    const formattedDate = petValues?.date
      ? moment(new Date(petValues.date)).format("YYYY-MM-DD")
      : null;

    if (
      !vetId ||
      !formattedDate ||
      !petValues?.appointmentOption ||
      !petValues?.consultationMode
    ) {
      return;
    }
    if (petValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(vetId));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId,
          type:
            (role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id) === vetId
              ? "Physical"
              : petValues?.consultationMode,
        }),
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId,
          date: formattedDate,
          clinicId: profile?.id,
        }),
      );
    }
  }, [
    petValues?.vetName?.value,
    petValues?.date,
    petValues?.appointmentOption,
    petValues?.consultationMode,
    role,
    profile?.id,
    clinicDet?.id,
  ]);

  const isPetInInpatientToday = () => {
    return inpatients?.some(
      (li) =>
        li?.petId === selectedPet?.petId &&
        moment(new Date(li?.appointmentdateTime)).format("YYYY-MM-DD") ===
          moment(new Date()).format("YYYY-MM-DD"),
    );
  };

  useEffect(() => {
    if (inpatients?.length > 0 && isPetInInpatientToday()) {
      setPetValues({
        ...petValues,
        date: getTomorrowDate(),
        appointmentOption: "Later",
      });
    }
  }, [inpatients, isPetInInpatientToday()]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  useEffect(() => {
    setBookingSearchPets([]);

    const value = petValues?.petSearch?.trim();
    if (!value) {
      petSearchReqIdRef.current += 1;
      return;
    }

    const timeoutId = setTimeout(() => {
      const reqId = ++petSearchReqIdRef.current;
      dispatch(
        getClinicPetsForBooking({
          userSearch: true,
          search: value,
          page: 1,
          itemSize: 30,
          petData: branchesDataSharing?.petData,
        }),
      ).then((res) => {
        if (reqId !== petSearchReqIdRef.current) return;
        setBookingSearchPets(res?.payload?.data ?? []);
      });
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [petValues?.petSearch, dispatch]);

  const getHolidayDateList = () => {
    const vetHolidays = holidays?.filter((hl) => hl?.type === "holliday");
    if (
      (vetHolidays?.length === 0 || !vetHolidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(vetHolidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const handleReset = () => {
    setPetValues(getInitValues());
    setPetErrors(initErrors);
    setSelectTime(null);
    setSelectTimeIdError(false);
  };

  const onCloseMod = () => {
    handleReset();
    setModOpen(false);
    setBookModVisible(false);
    setSelectTime(null);
  };

  const getAllOutstandingBlance = () => {
    return cutomerBillingApnt?.data?.length > 0
      ? cutomerBillingApnt?.data?.reduce(
          (acc, obj) => acc + Number(obj?.balanceDue ?? 0),
          0,
        )
      : 0;
  };

  const onChange = (value, name) => {
    const reqObj = { ...petValues, [name]: value };
    const errObj = { ...petErrors };
    if (name === "bookingType" && value === "Phone") {
      reqObj.appointmentOption = "Later";
    }
    if (name === "serviceType" && value === "Surgery") {
      reqObj.appointmentOption = "Later";
    }
    if (name === "petSearch") {
      setBookingSearchPets([]);
    }
    if (name === "serviceType") {
      reqObj.serviceName = [];
      reqObj.facility = null;
      // if (value?.value === "Surgery" || value?.value === "Grooming") {
      //   dispatch(getClinicFacilities());
      // }
    }
    if (name === "serviceName") {
      errObj.serviceName = value?.length === 0;
    }
    if (name === "consultationMode" && value === "Home") {
      dispatch(getUserDetailsById(selectedPet?.userId));
    }
    setPetErrors(errObj);
    setPetValues(reqObj);
  };

  const handleSelectectedTimeIds = (time) => {
    const reqTimeIds = [...timeObject?.times, time];
    let ids = [];
    const reqList = {
      times: reqTimeIds?.length > 2 ? [time] : reqTimeIds,
    };
    if (reqList?.times?.length === 2) {
      ids = getAllSelectedSlots(
        getRequiredSlotList({
          availability: vetAvailability,
          date: petValues?.date,
          bookedApnts: vetBookedApnts,
        }),
        reqTimeIds,
      );
      reqList.ids = ids;
    } else {
      ids.push(time);
      reqList.ids = ids;
    }
    setTimeObject(reqList);
    setSelectTimeIdError(reqTimeIds?.length === 2 ? false : true);
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setSelectTimeIdError(false);
  };

  const getHistoryList = () => {
    if (!petApntHistories || petApntHistories?.length === 0) return [];
    return petApntHistories?.map((hl) => ({
      name: `Case Id: ${hl?.caseId ?? ""} ${hl?.serviceType}${
        hl?.serviceType === "Consultation"
          ? ` | ${
              Array.isArray(hl?.reason) ? hl?.reason?.join(", ") : hl?.reason
            }`
          : ""
      }`,
      value: hl?.appointmentId,
    }));
  };

  const getServiceList = (itm) => {
    const reqCat =
      itm === "Grooming"
        ? "Hygiene & Grooming"
        : itm === "Lab Tests"
          ? "Lab"
          : itm === "Vaccination"
            ? "Preventive Care"
            : "Radiology";
    const reqList = [];
    let filList = services?.filter(
      (sl) =>
        sl?.active === "Y" &&
        sl?.category?.toLowerCase() === reqCat?.toLowerCase(),
    );
    if (itm === "Grooming") {
      if (facilities?.filter((fl) => fl?.type === "BathBays").length === 0) {
        filList = filList?.filter(
          (sl) =>
            sl?.subCategory !== "Bathing" &&
            sl?.subCategory !== "Spa/Pampering Services",
        );
      }
    }
    if (itm === "Vaccination") {
      filList = filList?.filter(
        (sl) => sl?.subCategory?.toLowerCase() === "vaccination",
      );
    }
    filList?.forEach((li) => {
      const clinicVariants = li?.serviceVariants?.filter((vr) =>
        vr?.createdBy ? vr?.createdBy === clinicDet?.id : true,
      );
      if (clinicVariants?.length > 0) {
        clinicVariants?.forEach((vrnt) => {
          const reqObj = {
            serviceId: li?.serviceId,
            serviceName: li?.serviceName,
            variantName: vrnt?.variantName ?? "",
            estimatedDuration: vrnt?.estimatedDuration ?? "",
            servicePrice: vrnt?.servicePrice ?? 0,
            variantId: vrnt?.variantId ?? null,
            value: vrnt?.variantName ?? "",
            name: vrnt?.variantName ?? "",
            category: li?.category,
            subCategory: li?.subCategory,
          };
          reqList.push(reqObj);
        });
      } else {
        const reqObj = {
          serviceId: li?.serviceId,
          serviceName: li?.serviceName,
          servicePrice: li?.servicePrice ?? 0,
          estimatedDuration: li?.estimatedDuration ?? "",
          name: li?.serviceName,
          value: li?.serviceName,
        };
        reqList.push(reqObj);
      }
    });
    return reqList ?? [];
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      petValues?.consultationMode === "Home"
        ? "HomeKit"
        : type === "Surgery"
          ? "OperationTheatre"
          : type === "Consultation" ||
              type === "Vaccination" ||
              type === "Lab Tests" ||
              type === "Radiology Tests" ||
              type === "Others"
            ? "ConsultationRoom"
            : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => (fl?.type ?? "")?.toLowerCase() !== "devices")
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];

    return reqVetList;
  };

  const getFacilityUnAvailListById = (id) => {
    const reqFacility = facilities?.find((fl) => fl?.facilityId === id) ?? {};
    if (!reqFacility) return [];
    return (
      reqFacility?.clinicFacilitiesUnavaility
        ?.filter(
          (ua) =>
            ua?.appointmentDate ===
            moment(petValues?.date).format("YYYY-MM-DD"),
        )
        ?.map((li) => ({
          ...li,
          startTime: li?.appointmentStartTime,
          endTime: li?.appointmentEndTime,
        })) ?? []
    );
  };

  const getBaseSlotList = () =>
    getRequiredSlotList({
      availability: vetAvailability,
      date: petValues?.date,
      bookedApnts: vetBookedApnts,
      holidays,
    });

  const getBookableSlotList = () => {
    const baseSlots = getBaseSlotList();
    if (!petValues?.facility?.value) return baseSlots;
    return getOnlyAvailableSlots(
      getFacilityUnAvailListById(petValues?.facility?.value),
      baseSlots,
    );
  };

  const onPreview = () => {
    const reqErrs = {};
    // if (
    //   petValues?.serviceType?.value === "Grooming" ||
    //   petValues?.serviceType?.value === "Lab Tests" ||
    //   petValues?.serviceType?.value === "Radiology Tests"
    //   // ||
    //   // petValues?.serviceType?.value === "Others"
    // ) {
    //   if (petValues?.serviceName?.length === 0) {
    //     reqErrs.serviceName = "This field is required";
    //   }
    // }
    if (!selectedPet) {
      reqErrs.petSearch = "This field is required";
    }
    if (
      Object.keys(reqErrs)?.length > 0 ||
      (petValues?.serviceType?.value !== "Surgery" &&
        petValues?.appointmentOption !== "Immediate" &&
        !selectTime) ||
      (petValues?.serviceType?.value === "Surgery" &&
        timeObject?.ids?.length < 2)
    ) {
      if (
        (petValues?.serviceType?.value !== "Surgery" &&
          petValues?.appointmentOption !== "Immediate" &&
          !selectTime) ||
        (petValues?.serviceType?.value === "Surgery" &&
          timeObject?.ids?.length < 2)
      ) {
        setSelectTimeIdError(true);
      }
      setPetErrors(reqErrs);
      return;
    }
    setPreviewModVsble(true);
    setModOpen(false);
  };

  const handleAddDiag = (petVal, apntId) => {
    const list = petVal?.serviceName;
    list?.forEach((li) => {
      const form = new FormData();
      form.append("appId", apntId);
      form.append("type", li?.category);
      form.append("testName", li?.serviceName);
      form.append("doneAt", doneAtList?.[0]?.value);
      form.append("sampleCollected", false);
      form.append("priority", "Routine");
      form.append("price", li?.servicePrice);
      form.append("tax", 0);
      form.append(
        "dueDate",
        moment(
          petVal?.appointmentOption === "Immediate"
            ? new Date()
            : new Date(petVal?.date),
        ).format("YYYY-MM-DD"),
      );
      form.append("remark", "");
      form.append("serviceId", li?.serviceId);
      form.append("variantId", li?.variantId);
      form.append("variantName", li?.variantName);
      form.append("status", "In Progress");
      dispatch(
        createDiagnosticsWoLoader({
          appointmentId: apntId,
          form,
          formData: true,
        }),
      );
    });
  };

  const handleAddProcedure = (petVal, apntId) => {
    const list = petVal?.serviceName;
    list?.forEach((li) => {
      const procedureDetails = getProcedureDetails(
        li?.serviceId,
        li?.variantId,
        li?.serviceName,
        services ?? [],
        clinicStocks ?? [],
        clinicDet?.pharmacyTaxId,
      )?.procedureDetails;
      const data = {
        procedureName: li?.serviceName,
        serviceId: li?.serviceId,
        category: li?.category,
        subCategory: li?.subCategory,
        remarks: li?.remarks ?? "",
        doneAt: moment(
          petVal?.appointmentOption === "Immediate"
            ? new Date()
            : new Date(petVal?.date),
        ).format("YYYY-MM-DD"),
        status: "Pending",
        petId: selectedPet?.petId,
        appointmentId: apntId,
        serviceCharge: li?.servicePrice,
        serviceType: li?.variantName,
        procedureDetails,
      };
      dispatch(createProcedureWoLoader({ data }));
    });
  };

  const handleSubmit = () => {
    dispatch(showLoader());
    const isImmediate = petValues?.appointmentOption === "Immediate";
    const startTime = isImmediate
      ? moment(new Date()).format("HH:mm")
      : selectTime;
    const data = {
      bookingType: petValues?.bookingType,
      consultationMode: petValues?.consultationMode,
      serviceType: petValues?.serviceType?.value,
      remarks: petValues?.remarks,
      immediate: isImmediate,
      appointmentDate: isImmediate
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment(new Date(petValues?.date)).format("YYYY-MM-DD"),
      doctorId: selectedVet?.doctorId ?? petValues?.vetName?.id,
      facility: petValues?.facility?.name ?? null,
      facilityId: petValues?.facility?.value ?? null,
      visitType: petValues?.visitType?.value,
    };
    if (petValues?.assignedUsers?.length > 0) {
      data.assignedUsers = petValues?.assignedUsers?.map((li) => li?.id);
    }

    if (petValues?.serviceType?.value === "Consultation") {
      data.reason = petValues?.reason;
      data.appointmentStartTime = startTime;
      data.appointmentEndTime = adjustTime(
        startTime,
        getRequiredSlotList({
          availability: vetAvailability,
          date: petValues?.date,
          isDuration: true,
        }),
      );
    }

    if (petValues?.serviceType?.value === "Surgery") {
      data.appointmentStartTime = isImmediate
        ? startTime
        : timeObject?.ids?.[0]?.startTime;
      data.appointmentEndTime = isImmediate
        ? adjustTime(
            isImmediate
              ? startTime
              : timeObject?.ids?.[timeObject?.ids?.length - 1]?.startTime,
            getRequiredSlotList({
              availability: vetAvailability,
              date: petValues?.date,
              isDuration: true,
            }),
          )
        : timeObject?.ids?.[timeObject?.ids?.length - 1]?.startTime;
    }

    if (
      petValues?.serviceType?.value !== "Consultation" &&
      petValues?.serviceType?.value !== "Surgery"
    ) {
      data.serviceNames = petValues?.serviceName?.map((li) => ({
        serviceName: li?.serviceName,
        serviceId: li?.serviceId,
        variantId: li?.variantId,
      }));
      const reqTimeInMins =
        petValues?.serviceType?.value === "Others"
          ? 0
          : petValues?.serviceName?.reduce((acc, obj) => {
              return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
            }, 0);
      data.appointmentStartTime = startTime;
      data.appointmentEndTime = adjustTime(
        startTime,
        reqTimeInMins > 0
          ? reqTimeInMins
          : getRequiredSlotList({
              availability: vetAvailability,
              date: petValues?.date,
              isDuration: true,
            }),
      );
      if (
        petValues?.serviceName?.some(
          (item) =>
            item?.subCategory?.includes("Bathing") ||
            item?.subCategory?.includes("Spa/Pampering Services"),
        )
      ) {
        if (facilities?.filter((fl) => fl?.type === "BathBays")?.length === 1) {
          data.facility =
            petValues?.facility?.name ??
            getFacilitiesByType("Grooming")?.[0]?.name ??
            null;
          data.facilityId =
            petValues?.facility?.value ??
            getFacilitiesByType("Grooming")?.[0]?.value ??
            null;
        } else {
          const reqFacility = getAvailableBayAtTime(
            facilities?.filter((fl) => fl?.type === "BathBays"),
            selectTime,
            moment(petValues?.date).format("YYYY-MM-DD"),
          );
          if (reqFacility) {
            data.facility =
              petValues?.facility?.name ?? reqFacility?.name ?? null;
            data.facilityId =
              petValues?.facility?.value ?? reqFacility?.facilityId ?? null;
          }
        }
      }
    }
    if (
      petValues?.visitType?.value === "Follow-up" &&
      petValues?.referenceCase?.value
    ) {
      data.prevAppointmentId = petValues?.referenceCase?.value;
    }

    // if (petValues?.appointmentOption !== "Immediate") {
    //   if (petValues?.serviceType?.value === "Surgery") {
    //     data.appointmentStartTime = timeObject?.ids?.[0]?.startTime;
    //     data.appointmentEndTime =
    //       timeObject?.ids?.[timeObject?.ids?.length - 1]?.endTime;
    //     data.facility = petValues?.facility?.name;
    //     data.facilityId = petValues?.facility?.value;
    //   } else {
    //     data.appointmentStartTime = selectTime;
    //     data.appointmentEndTime = adjustTime(
    //       selectTime,
    //       getRequiredSlotList({
    //         availability: vetAvailability,
    //         date: petValues?.date,
    //         isDuration: true,
    //       })
    //     );
    //   }
    // }
    // if (
    //   petValues?.serviceType?.value === "Grooming" &&
    //   petValues?.appointmentOption !== "Immediate"
    // ) {
    //   if (petValues?.serviceName?.length === 0) return;
    //   if (
    //     petValues?.serviceName?.some(
    //       (item) =>
    //         item?.subCategory?.includes("Bathing") ||
    //         item?.subCategory?.includes("Spa/Pampering Services")
    //     )
    //   ) {
    //     const reqTimeInMins = petValues?.serviceName?.reduce((acc, obj) => {
    //       return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
    //     }, 0);
    //     data.appointmentStartTime = selectTime;
    //     data.appointmentEndTime = adjustTime(selectTime, reqTimeInMins);
    //     if (facilities?.filter((fl) => fl?.type === "BathBays")?.length === 1) {
    //       data.facility = getFacilitiesByType("Grooming")?.[0]?.name;
    //       data.facilityId = getFacilitiesByType("Grooming")?.[0]?.value;
    //     } else {
    //       const reqFacility = getAvailableBayAtTime(
    //         facilities?.filter((fl) => fl?.type === "BathBays"),
    //         selectTime
    //       );
    //       if (reqFacility) {
    //         data.facility = reqFacility?.name;
    //         data.facilityId = reqFacility?.facilityId;
    //       }
    //     }
    //   }
    //   // else {
    //   //   data.appointmentStartTime = selectTime;
    //   //   data.appointmentEndTime = adjustTime(
    //   //     selectTime,
    //   //     getRequiredSlotList({
    //   //       availability: vetAvailability,
    //   //       date: petValues?.date,i
    //   //       isDuration: true,
    //   //     })
    //   //   );
    //   // }
    // }
    // if (
    //   petValues?.serviceType?.value === "Radiology Tests" &&
    //   petValues?.appointmentOption !== "Immediate"
    // ) {
    //   if (petValues?.serviceName?.length === 0) return;
    //   if (
    //     petValues?.serviceName?.some(
    //       (item) =>
    //         item?.subCategory?.includes("Imaging") ||
    //         item?.subCategory?.includes("Endoscopy")
    //     )
    //   ) {
    //     const reqTimeInMins = petValues?.serviceName?.reduce((acc, obj) => {
    //       return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
    //     }, 0);
    //     data.appointmentStartTime = selectTime;
    //     data.appointmentEndTime = adjustTime(selectTime, reqTimeInMins);
    //   }
    // }
    // if (petValues?.serviceType?.value === "Consultation") {
    //   data.reason = petValues?.reason;
    // }
    dispatch(petAppointment({ data, petId: selectedPet?.petId })).then(
      (res) => {
        if (res?.payload) {
          handleCloseMod("apiSuccess");
          if (
            (petValues?.serviceType?.value === "Radiology Tests" ||
              petValues?.serviceType?.value === "Lab Tests" ||
              petValues?.serviceType?.value === "Grooming") &&
            res?.payload?.data?.appointmentId
          ) {
            if (
              petValues?.serviceType?.value === "Radiology Tests" ||
              petValues?.serviceType?.value === "Lab Tests"
            ) {
              handleAddDiag(petValues, res?.payload?.data?.appointmentId);
            }
            if (petValues?.serviceType?.value === "Grooming") {
              handleAddProcedure(petValues, res?.payload?.data?.appointmentId);
            }
          }

          setPreviewModVsble(false);
          setBookModVisible(false);
          onCloseMod();
          dispatch(hideLoader());
        }
      },
    );
    dispatch(hideLoader());
  };

  const onClosePreviewMod = () => {
    setModOpen(true);
    setPreviewModVsble(false);
  };

  const getAllClinicUserListWoSelectedVet = (vetId) => {
    if (!vetId) return [];
    const reqVetList =
      clinicVets
        ?.filter(
          (vl) =>
            vl?.status === "Y" &&
            vl?.doctorId !== vetId &&
            vl?.userType?.some(
              (ut) => ut?.name === "ROLE_DOCTOR" || ut?.name === "ROLE_GROOMER",
            ),
        )
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
          };
        })
        ?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")) ?? [];
    return reqVetList;
  };

  const getAppointmentHistoryStats = () => {
    if (!petApntHistories || petApntHistories?.length === 0) {
      return {
        lastAppointment: null,
        totalAppointments: 0,
        noShows: 0,
      };
    }

    // Sort by date to get the most recent appointment
    const sortedHistories = [...petApntHistories].sort((a, b) => {
      const dateA = new Date(
        a?.appointmentDate ||
          a?.date ||
          a?.appointmentDateTime ||
          a?.visitDate ||
          0,
      );
      const dateB = new Date(
        b?.appointmentDate ||
          b?.date ||
          b?.appointmentDateTime ||
          b?.visitDate ||
          0,
      );
      return dateB - dateA;
    });

    const lastAppointment = sortedHistories[0];
    const totalAppointments = petApntHistories?.length || 0;

    // Count no shows - checking for "noshow", "no-show", "no show" or "cancelled" status
    const noShows =
      petApntHistories?.filter((apt) => {
        const status =
          apt?.appointmentStatus?.toLowerCase() ||
          apt?.status?.toLowerCase() ||
          "";
        return (
          status.includes("noshow") ||
          status.includes("no-show") ||
          status.includes("no show") ||
          status === "cancelled"
        );
      }).length || 0;

    return {
      lastAppointment,
      totalAppointments,
      noShows,
    };
  };

  const getVetList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => {
          const isDoctor = vl?.userType?.find(
            (ut) => ut?.name === "ROLE_DOCTOR",
          );
          return isDoctor && vl?.schedulable;
        })
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            facility: vet?.facility,
          };
        })
        ?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : clinicDet?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      facility: null,
    });
    return reqVetList;
  };

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.schedulable && vl?.status === "Y")
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            facility: vet?.facility,
          };
        })
        ?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : clinicDet?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      facility: null,
    });
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType = type === "Grooming" ? "ROLE_GROOMER" : "ROLE_RADIOLOGY";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.schedulable && vl?.userRole === reqType)
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            facility: vet?.facility,
          };
        }) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : clinicDet?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      facility: null,
    });
    return reqVetList;
  };

  const getBookableVetList = () => {
    if (
      petValues?.serviceType?.value === "Grooming" ||
      petValues?.serviceType?.value === "Lab Tests" ||
      petValues?.serviceType?.value === "Radiology Tests"
    ) {
      return getOthersByType(petValues?.serviceType?.value);
    }
    if (petValues?.serviceType?.value === "Others") {
      return getAllClinicUserList();
    }
    return getVetList();
  };

  const onCloseCreatePet = (e, pet) => {
    if (e === "petCreated") {
      setPetValues({ ...petValues, petSearch: "" });
      if (pet?.petId) {
        dispatch(getAppointmentHistoriesByPetId(pet?.petId));
        dispatch(getPetDetailsById(pet?.petId));
      }
      if (pet?.userId) {
        dispatch(getBillingsByCustomerIdForApntBook(pet?.userId));
      }
      setSelectedPet({
        breed: pet?.breed,
        dob: pet?.dob,
        gender: pet?.gender,
        petId: pet?.petId,
        petName: pet?.petName,
        status: pet?.status === "Y",
        userId: pet?.userId,
        color: pet?.color,
        weight: pet?.weight,
        userName: pet?.userName,
      });
    }
    setCreatePetModVsble(false);
  };

  const onRegisterPet = () => {
    setSelectedPet(null);
    setCreatePetModVsble(true);
  };

  const onChangePet = () => {
    setSelectedPet(null);
  };

  const onChangeType = (typ) => {
    if (typ === "internalUse") {
      const resolvedStartTime = resolveInternalStartTime(
        selectedVet?.date,
        selectedVet?.startTime,
      );
      const resolvedSlotSize = slotSize || 15;
      setInternalValues({
        titleError: false,
        title: "",
        date: selectedVet?.date ?? new Date(),
        startTime: resolvedStartTime,
        endTime: resolveInternalEndTime(resolvedStartTime, resolvedSlotSize),
        remarks: "",
        users: [],
      });
    }
    setType(typ);
  };

  const onChangeInternalValue = (name, value) => {
    const reqObj = { ...internalValues, [name]: value };
    if (name == "title") {
      reqObj.titleError = value?.trim()?.length === 0 ? true : false;
    }
    setInternalValues(reqObj);
  };

  const refreshAndPatchVetUnavailability = () => {
    try {
      dispatch(getClinicVetsUnavailabilityWoLoader()).then((res) => {
        try {
          const payload = res?.payload;
          if (payload == null) return;
          const list = Array.isArray(payload)
            ? payload
            : Array.isArray(payload?.data)
              ? payload.data
              : [];
          patchMandateSession({ vetUnavailability: list });
        } catch {
          // ignore mandate patch errors
        }
      });
    } catch {
      // ignore unavailability refresh errors
    }
  };

  const onSaveInternalUse = () => {
    if (internalValues?.title?.trim()?.length === 0) {
      return setInternalValues({ ...internalValues, titleError: true });
    }
    const data = {
      title: internalValues?.title,
      holliday: internalValues?.remarks,
      date: moment(new Date(internalValues?.date)).format("YYYY-MM-DD"),
      endDate: moment(new Date(internalValues?.date)).format("YYYY-MM-DD"),
      startTime: moment(new Date(internalValues?.startTime)).format("HH:mm"),
      endTime: moment(new Date(internalValues?.endTime)).format("HH:mm"),
      type: "unavailability",
      doctorsIds: (internalValues?.users ?? [])?.map((li) => li?.value),
    };

    if (editUnavailabilityId) {
      dispatch(
        updateVetHolidaysById({
          id: editUnavailabilityId,
          vetId: selectedVet?.doctorId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) {
          refreshAndPatchVetUnavailability();
          handleCloseMod("apiSuccess");
          return;
        }
      });
    } else {
      dispatch(
        storeVetHolidaysById({ vetId: selectedVet?.doctorId, data }),
      ).then((res) => {
        if (res?.payload) {
          refreshAndPatchVetUnavailability();
          handleCloseMod("apiSuccess");
          setPreviewModVsble(false);
          setBookModVisible(false);
          onCloseMod();
          setInternalValues({});
        }
      });
    }
  };

  return (
    <>
      <CustomModal
        open={modOpen}
        onClose={onCloseMod}
        header={
          editUnavailabilityId
            ? "Update Unavailability"
            : type === "internalUse"
              ? "Internal Use"
              : "Book an Appointment"
        }
        modalWidth={type === "internalUse" ? 30 : 80}
        modal
      >
        {addExtraOption && !selectedVet?.facility ? (
          <div className="ph20">
            <CustomCheckbox
              radio
              value={type}
              onChange={(e) => onChangeType(e?.target?.value)}
              radios={[
                { label: "Appointment", value: "appointment" },
                { label: "Internal Use", value: "internalUse" },
              ]}
            />
          </div>
        ) : null}
        {type === "internalUse" ? (
          <Grid container spacing={2} className="ph20 scroll-80vh-new">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                placeholder="Title"
                fullWidth
                value={internalValues?.title}
                handleChange={(e) =>
                  onChangeInternalValue("title", e?.target?.value)
                }
                label="Title"
                required
                error={internalValues?.titleError}
                helperText={
                  internalValues?.titleError ? "This field is required" : ""
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                name="date"
                value={internalValues?.date}
                fullWidth
                handleChange={(e) =>
                  onChangeInternalValue("date", e?.target?.value)
                }
                mobileDate
                minDate={new Date()}
                label="Date"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <CustomTextField
                name="startTime"
                value={internalValues?.startTime}
                fullWidth
                handleChange={(e) =>
                  onChangeInternalValue("startTime", e?.target?.value)
                }
                mobileTime
                is12HourFomat={false}
                minDate={new Date()}
                label="Start Time"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <CustomTextField
                name="endTime"
                value={internalValues?.endTime}
                fullWidth
                handleChange={(e) =>
                  onChangeInternalValue("endTime", e?.target?.value)
                }
                mobileTime
                is12HourFomat={false}
                minDate={new Date()}
                label="End Time"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                name="remarks"
                fullWidth
                handleChange={(e) =>
                  onChangeInternalValue("remarks", e?.target?.value)
                }
                value={internalValues?.remarks}
                label="Remarks"
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Select
                list={getAllClinicUserListWoSelectedVet(
                  petValues?.vetName?.value,
                )}
                value={internalValues?.users ?? []}
                name="users"
                handleChange={(e) => {
                  onChangeInternalValue("users", e?.target?.value);
                }}
                label="Users"
                multiSelectSearchCheck
              />
            </Grid>
            <div className="flex1-center mt20 mb10">
              <div>
                <CustomButton
                  text="Save"
                  smallBtn
                  onClick={onSaveInternalUse}
                />
              </div>
            </div>
          </Grid>
        ) : null}
        {type === "appointment" ? (
          <>
            <Grid container spacing={2} className="ph20">
              <Grid item xs={12} sm={12} md={3.5} lg={3.5} xl={3.5}>
                <div className="scroll-80vh-new">
                  {!selectedPet && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="mb20"
                    >
                      <div>
                        <CustomTextField
                          fullWidth
                          search
                          placeholder="Pet / Customer Search"
                          backgroundColor={AppColors.lightBlue2}
                          value={petValues?.petSearch}
                          handleChange={(e) =>
                            onChange(e?.target?.value, "petSearch")
                          }
                        />
                        {petErrors?.petSearch && (
                          <Typography color="error" className="ml5 mt5 fs14">
                            Pet is Required
                          </Typography>
                        )}
                        {petValues?.petSearch?.length > 0 &&
                        (bookingSearchPets ?? [])?.length === 0 ? (
                          <div className="flex-row-ali-cen mt10 w100Per">
                            <div className="fs14 gray4 font-medium">
                              Can’t find the pet?{" "}
                              <span
                                className="fs14 txt-semi-bold blue-color cursor underline"
                                onClick={onRegisterPet}
                              >
                                Register Pet
                              </span>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </Grid>
                  )}

                  <Grid container className="flex-center">
                    {petValues?.petSearch?.length > 0 && (
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        {(bookingSearchPets ?? [])?.length > 0 &&
                          (bookingSearchPets ?? [])
                            ?.filter((li) => li?.listOfDatas?.status)
                            ?.map((petDet) => {
                              const pet = petDet?.listOfDatas;
                              return (
                                <Grid
                                  container
                                  spacing={1}
                                  key={pet?.petId}
                                  className="cursor"
                                  onClick={() => {
                                    setSelectedPet(pet);
                                    setPetValues({
                                      ...petValues,
                                      petSearch: "",
                                    });
                                    setPetErrors({
                                      ...petErrors,
                                      petSearch: false,
                                    });
                                    dispatch(
                                      getAppointmentHistoriesByPetId(
                                        pet?.petId,
                                      ),
                                    );
                                    dispatch(getPetDetailsById(pet?.petId));
                                    if (pet?.userId) {
                                      dispatch(
                                        getBillingsByCustomerIdForApntBook(
                                          pet?.userId,
                                        ),
                                      );
                                    }
                                  }}
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                  >
                                    <Grid container spacing={1}>
                                      <Grid item xs={12}>
                                        <Card
                                          sx={{
                                            borderRadius: 1,
                                            padding: 2,
                                            borderTopColor:
                                              AppColors.appPrimary,
                                          }}
                                          className="CustomCard-back-appointment"
                                        >
                                          <div className="maint">
                                            <div className="flex-row">
                                              <Grid item xs={3}>
                                                <div className="flex-center">
                                                  {pet?.petImage ? (
                                                    <CardMedia
                                                      image={pet?.petImage}
                                                      className="CustomCard-img3-bill"
                                                    />
                                                  ) : (
                                                    <div className="flex-center h50img">
                                                      <Typography className="font-bold fs30 white-color capitalize">
                                                        {pet?.petName?.[0]}
                                                      </Typography>
                                                    </div>
                                                  )}
                                                </div>
                                              </Grid>
                                              <Grid item xs={9}>
                                                <div className="flex-row">
                                                  <div className="flex-start">
                                                    <div className="flex-column">
                                                      <div className="flex-row">
                                                        <Typography
                                                          variant="body1"
                                                          className="mb10 font-bold fs14 capitalize"
                                                        >
                                                          {pet?.petName}
                                                        </Typography>
                                                        <Typography
                                                          variant="body1"
                                                          className={`ml5 font-medium capitalize fs14 ${
                                                            pet.gender ===
                                                            "male"
                                                              ? "card-blue-color"
                                                              : "card-rose-color"
                                                          }`}
                                                        >
                                                          ({pet.gender})
                                                        </Typography>
                                                      </div>
                                                      <Typography
                                                        variant="body2"
                                                        className="mb10 txt-regular card-gray-color fs12"
                                                      >
                                                        {pet.breed}
                                                      </Typography>
                                                    </div>
                                                  </div>
                                                </div>
                                              </Grid>
                                            </div>
                                            <div>
                                              <div className="flex-row parentcontainer">
                                                <div className="flex-row iconcontainer">
                                                  <AccountCircleOutlinedIcon
                                                    sx={{
                                                      width: 25,
                                                      height: 25,
                                                    }}
                                                  />
                                                  <Typography className="font-bold fs14 capitalize flex-center h35">
                                                    {pet.userName}
                                                  </Typography>
                                                </div>
                                                <div className="meeting-doctor">
                                                  {moment(pet?.dob).fromNow()} (
                                                  {pet?.dob})
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Card>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              );
                            })}
                      </Grid>
                    )}
                  </Grid>

                  <Grid container className="flex-center">
                    {selectedPet && (
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div
                          className="flex1-end fs14 txt-semi-bold red5 cursor mb5"
                          onClick={onChangePet}
                        >
                          Change Pet
                        </div>
                        <Card
                          sx={cardSty}
                          // className="CustomCard-back-appointment"
                        >
                          {/* <div className="maint"> */}
                          <div className="flex-row">
                            <Grid item xs={3}>
                              <div className="flex-center">
                                {selectedPet?.petImage ? (
                                  <CardMedia
                                    image={selectedPet?.petImage}
                                    className="CustomCard-img3-bill"
                                  />
                                ) : (
                                  <div className="flex-center h50img">
                                    <Typography className="font-bold fs30 white-color capitalize">
                                      {selectedPet?.petName?.[0]}
                                    </Typography>
                                  </div>
                                )}
                              </div>
                            </Grid>
                            <Grid item xs={9}>
                              <div className="flex-row">
                                <div className="flex-start">
                                  <div className="flex-column">
                                    <div className="flex-row">
                                      <Typography className="mb10 txt-semi-bold fs14 card-black capitalize">
                                        {selectedPet?.petName}
                                      </Typography>
                                      <Typography
                                        className={`ml5 font-medium capitalize fs14 ${
                                          selectedPet?.gender === "male"
                                            ? "card-blue-color"
                                            : "card-rose-color"
                                        }`}
                                      >
                                        {`(${selectedPet?.gender})`}
                                      </Typography>
                                    </div>
                                    <Typography className="mb10 txt-regular card-gray-color fs12">
                                      {selectedPet?.breed}
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          </div>
                          {/* </div> */}
                        </Card>

                        <div className="flex-row-ali-cen mt10">
                          <DataUsageIcon sx={w25h25BlueIcon} />
                          <Typography className="txt-semi-bold gray39 fs14 ml10">
                            Age :{" "}
                          </Typography>
                          <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                            {getPetAgeDisplay(selectedPet?.dob)} (
                            {selectedPet?.dob})
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen mt10">
                          <ColorLensIcon sx={w25h25BlueIcon} />
                          <Typography className="txt-semi-bold gray39 fs14 ml10">
                            Color :{" "}
                          </Typography>
                          <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                            {selectedPet?.color ?? ""}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen mt10">
                          <ScaleIcon sx={w25h25BlueIcon} />
                          <Typography className="txt-semi-bold gray39 fs14 ml10">
                            Weight :{" "}
                          </Typography>
                          <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                            {selectedPet?.weight?.length > 0
                              ? `${selectedPet?.weight} KG`
                              : ""}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen mt10">
                          <AccountCircleOutlinedIcon sx={w25h25BlueIcon} />
                          <Typography className="txt-semi-bold gray39 fs14 ml10">
                            Parent Name :{" "}
                          </Typography>
                          <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                            {selectedPet?.userName}{" "}
                            {(selectedPet?.userMobile ?? selectedPet?.mobile)
                              ?.length > 0 &&
                              ` (${selectedPet?.userMobile ?? selectedPet?.mobile})`}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen mb5 mt15">
                          <div className="flex-row-wrap flex-row">
                            <img
                              src={require("../../../assets/images/png/allergyIcon.png")}
                              alt=""
                              className="img-wh20"
                            />
                            <Typography className="txt-semi-bold fs14 balck ml10">
                              Alerts:
                            </Typography>
                            {petDetails?.allergies?.length > 0 ? (
                              petDetails?.allergies?.map((al, i) => (
                                <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                                  {`${al?.allergies}${
                                    i + 1 === petDetails?.allergies?.length
                                      ? ""
                                      : ","
                                  }`}
                                </Typography>
                              ))
                            ) : (
                              <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                                None specified
                              </Typography>
                            )}
                          </div>
                        </div>
                        {petDetails?.petInternalTags?.length > 0 ? (
                          <>
                            <Typography className="text-bold fs14 blue-color">
                              Internal Tags
                            </Typography>
                            <div className="flex-row-wrap1">
                              {petDetails?.petInternalTags?.map((tg) => (
                                <div
                                  className="flex-row-ali-cen pv5 ph10 cursor br5 mh5 mv5"
                                  style={{ background: tg?.color }}
                                  key={tg?.internalId}
                                >
                                  <Typography className="font-bold fs10 white-color">
                                    {tg?.tags}
                                  </Typography>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : null}

                        {/* Appointment History Section */}
                        {(() => {
                          const stats = getAppointmentHistoryStats();
                          const lastVisitDate =
                            petDetails?.lastVisitDate ||
                            stats?.lastAppointment?.appointmentDate ||
                            stats?.lastAppointment?.date ||
                            stats?.lastAppointment?.appointmentDateTime ||
                            stats?.lastAppointment?.visitDate;
                          return (
                            <div className="mt5">
                              <Typography className="text-bold blue-color fs14">
                                Appointment History
                              </Typography>
                              {lastVisitDate && (
                                <div>
                                  <div className="flex-row-ali-cen">
                                    <Typography className="txt-semi-bold gray39 fs14">
                                      Last Appointment :{" "}
                                    </Typography>
                                    <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                                      {moment(lastVisitDate).format(
                                        "DD MMM YYYY, HH:mm",
                                      )}
                                    </Typography>
                                  </div>
                                  {(petDetails?.vetName ||
                                    stats?.lastAppointment?.doctorName ||
                                    stats?.lastAppointment?.vetName) && (
                                    <div className="flex-row-ali-cen">
                                      <Typography className="txt-semi-bold gray39 fs14">
                                        Vet :{" "}
                                      </Typography>
                                      <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                                        {petDetails?.vetName ||
                                          stats?.lastAppointment?.doctorName ||
                                          stats?.lastAppointment?.vetName}
                                      </Typography>
                                    </div>
                                  )}
                                </div>
                              )}
                              <div className="flex-row-ali-cen">
                                <Typography className="txt-semi-bold gray39 fs14">
                                  Total Appointments :{" "}
                                </Typography>
                                <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                                  {petDetails?.totalAppointments ||
                                    stats?.totalAppointments ||
                                    0}
                                </Typography>
                              </div>
                              <div className="flex-row-ali-cen">
                                <Typography className="txt-semi-bold gray39 fs14">
                                  No Shows :{" "}
                                </Typography>
                                <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                                  {petDetails?.noShows !== null &&
                                  petDetails?.noShows !== undefined
                                    ? petDetails?.noShows
                                    : stats?.noShows || 0}
                                </Typography>
                              </div>
                              <Typography className="font-bold fs12 red-color">
                                Outstanding:{" "}
                                {(Number(getAllOutstandingBlance()) ?? 0 > 0)
                                  ? `Rs ${Number(getAllOutstandingBlance()).toFixed(2)}`
                                  : "Nil"}
                              </Typography>
                              <Typography className="mt5 font-bold fs12 green-color">
                                Credits:{" "}
                                {Number(petDetails?.advanceAmount)
                                  ? `Rs ${Number(petDetails?.advanceAmount).toFixed(2)}`
                                  : "Nil"}
                              </Typography>
                            </div>
                          );
                        })()}
                      </Grid>
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={8.5} lg={8.5} xl={8.5}>
                <div className="scroll-80vh-new">
                  <div className="flex-row">
                    <div className="w2Per">
                      <div className="gry-ver-split" />
                    </div>
                    <div className="w98Per">
                      <Grid container spacing={2} className="mt5">
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          <CustomSelect
                            list={typeAppointemnt}
                            value={petValues?.bookingType}
                            handleChange={(e) =>
                              onChange(e?.target?.value, "bookingType")
                            }
                            name="bookingType"
                            label="Booking Type * "
                            select
                            helperText={petErrors?.bookingType}
                            error={!!petErrors?.bookingType}
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          <CustomSelect
                            list={
                              petValues.bookingType === "Walk-in"
                                ? typeListNew
                                : typeList
                            }
                            value={
                              petValues?.bookingType === "Walk-in"
                                ? "Physical"
                                : petValues?.consultationMode
                            }
                            handleChange={(e) =>
                              onChange(e?.target?.value, "consultationMode")
                            }
                            name="consultationMode"
                            label="Consultation Mode * "
                            select
                            helperText={petErrors?.consultationMode}
                            error={!!petErrors?.consultationMode}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <CustomSelect
                            list={
                              petValues?.consultationMode === "Physical"
                                ? serviceTypes
                                : serviceTypeWOSurgery
                            }
                            value={petValues?.serviceType}
                            handleChange={(e, value) =>
                              onChange(value, "serviceType")
                            }
                            search
                            helperText={petErrors?.serviceType}
                            error={!!petErrors?.serviceType}
                            label="Service Type *"
                            name="serviceType"
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <CustomSelect
                            list={visitTypes}
                            value={petValues?.visitType}
                            handleChange={(e, value) =>
                              onChange(value, "visitType")
                            }
                            search
                            helperText={petErrors?.visitType}
                            error={!!petErrors?.visitType}
                            label="Visit Type *"
                            name="visitType"
                          />
                        </Grid>
                        {petValues?.serviceType?.value === "Consultation" ? (
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CustomSelect
                              list={oldIssueList}
                              value={petValues?.reason}
                              handleChange={(e) => {
                                onChange(e, "reason");
                              }}
                              reason
                              label="Reason"
                              name="reason"
                              helperText={petErrors?.reason}
                              error={!!petErrors?.reason}
                            />
                          </Grid>
                        ) : null}
                        {petValues?.visitType?.value === "Follow-up" ? (
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CustomSelect
                              list={getHistoryList()}
                              value={petValues?.referenceCase}
                              handleChange={(e, value) =>
                                onChange(value, "referenceCase")
                              }
                              search
                              label="Reference Case"
                              name="referenceCase"
                              helperText={petErrors?.referenceCase}
                              error={!!petErrors?.referenceCase}
                            />
                          </Grid>
                        ) : null}
                        {petValues?.serviceType?.value === "Grooming" ||
                        petValues?.serviceType?.value === "Lab Tests" ||
                        petValues?.serviceType?.value === "Radiology Tests" ||
                        // petValues?.serviceType?.value === "Others" ||
                        petValues?.serviceType?.value === "Vaccination" ? (
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CustomSelect
                              list={getServiceList(
                                petValues?.serviceType?.value,
                              )}
                              value={petValues?.serviceName}
                              handleChange={(e) => onChange(e, "serviceName")}
                              service
                              label="Service Name"
                              // label="Service Name *"
                              name="serviceName"
                              helperText={petErrors?.serviceName}
                              error={!!petErrors?.serviceName}
                            />
                          </Grid>
                        ) : null}
                        <Grid
                          item
                          xs={
                            petValues?.serviceType?.value === "Surgery" ? 6 : 12
                          }
                          sm={
                            petValues?.serviceType?.value === "Surgery" ? 6 : 12
                          }
                          md={
                            petValues?.serviceType?.value === "Surgery" ? 6 : 12
                          }
                          lg={
                            petValues?.serviceType?.value === "Surgery" ? 6 : 12
                          }
                          xl={
                            petValues?.serviceType?.value === "Surgery" ? 6 : 12
                          }
                        >
                          <Select
                            list={
                              selectedVet
                                ? selectedVet?.facility
                                  ? getBookableVetList()
                                  : [
                                      {
                                        name: selectedVet?.name,
                                        value: selectedVet?.doctorId,
                                        id: selectedVet?.doctorId,
                                      },
                                    ]
                                : getBookableVetList()
                            }
                            value={petValues?.vetName}
                            handleChange={(e, value) =>
                              onChange(value, "vetName")
                            }
                            name="vetName"
                            search
                            helperText={petErrors?.vetName}
                            error={!!petErrors?.vetName}
                            label={`${
                              petValues?.serviceType?.value === "Grooming"
                                ? "Groomer"
                                : petValues?.serviceType?.value ===
                                      "Lab Tests" ||
                                    petValues?.serviceType?.value ===
                                      "Radiology Tests"
                                  ? "Technician"
                                  : // : petValues?.serviceType?.value === "Others"
                                    // ? "Others"
                                    "Vet"
                            } Name *`}
                            labelTop
                            disabled={
                              selectedVet ? !selectedVet?.facility : false
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Select
                            list={getAllClinicUserListWoSelectedVet(
                              petValues?.vetName?.value,
                            )}
                            value={petValues?.assignedUsers ?? []}
                            name="assignedUsers"
                            handleChange={(e) => {
                              onChange(e?.target?.value, "assignedUsers");
                            }}
                            label="Assigned Users"
                            multiSelectSearchCheck
                          />
                        </Grid>
                        {petValues?.consultationMode === "Physical" ||
                        petValues?.consultationMode === "Home" ? (
                          // petValues?.serviceType?.value === "Surgery"
                          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Select
                              list={getFacilitiesByType(
                                petValues?.serviceType?.value,
                              )}
                              value={petValues?.facility}
                              handleChange={(e, value) =>
                                onChange(value, "facility")
                              }
                              name="facility"
                              search
                              helperText={petErrors?.facility}
                              error={!!petErrors?.facility}
                              label={
                                petValues?.consultationMode === "Home"
                                  ? "Kit Name"
                                  : "Facility"
                              }
                              labelTop
                              disabled={selectedVet?.facility}
                            />
                          </Grid>
                        ) : null}
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <div className="flex-row-ali-cen mtMin5">
                            <div className="gray7 fs14 mtMin5 txt-semi-bold">
                              Appointment <span className="red-color">*</span> :
                            </div>
                            <div className="ml5">
                              <CustomCheckbox
                                radio
                                value={petValues?.appointmentOption}
                                onChange={(e) =>
                                  onChange(
                                    e?.target?.value,
                                    "appointmentOption",
                                  )
                                }
                                radios={
                                  petValues.bookingType === "Phone" ||
                                  petValues?.serviceType?.value === "Surgery" ||
                                  isPetInInpatientToday()
                                    ? appointmentLaterList
                                    : appointmentList
                                }
                                defaultValue={petValues?.appointmentOption}
                              />
                            </div>
                          </div>
                          {isPetInInpatientToday() && (
                            <Typography className="red2 fs12 txt-regular">
                              Patient is currently under inpatient
                            </Typography>
                          )}
                          {petErrors?.appointmentOption && (
                            <Typography color="error" className="ml5 mt5 fs14">
                              Appointment is Required
                            </Typography>
                          )}
                        </Grid>
                        {/* {petValues?.serviceType?.value === "Surgery" &&
        petValues?.appointmentOption === "Immediate" ? (
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <CustomTextField
              name="kennelNumber"
              fullWidth
              handleChange={(e) => onChange(e?.target?.value, "kennelNumber")}
              value={petValues?.kennelNumber}
              helperText={petErrors?.kennelNumber}
              error={!!petErrors?.kennelNumber}
              label="Kennel Number "
            />
          </Grid>
        ) : null} */}
                        {petValues?.appointmentOption === "Later" && (
                          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <div className="mb20">
                              <CustomTextField
                                name="date"
                                value={petValues?.date}
                                labelTop
                                fullWidth
                                handleChange={(e) =>
                                  onChange(e?.target?.value, "date")
                                }
                                mobileDateWithBatch
                                markDateList={holidayDates ?? []}
                                minDate={
                                  isPetInInpatientToday()
                                    ? getTomorrowDate()
                                    : new Date()
                                }
                              />
                            </div>
                          </Grid>
                        )}
                        {petValues?.appointmentOption === "Later" &&
                          petValues?.date &&
                          petValues?.vetName?.value && (
                            <div className="w100Per">
                              <div className="flex-row-wrap1 mh10">
                                {getBookableSlotList()?.length > 0 ? (
                                  getBookableSlotList()?.map((item, i) => {
                                    return (
                                      <div
                                        key={i}
                                        onClick={() => {
                                          petValues?.serviceType?.value ===
                                          "Surgery"
                                            ? handleSelectectedTimeIds(item)
                                            : handleSelectTime(item);
                                        }}
                                        className={
                                          (
                                            petValues?.serviceType?.value ===
                                            "Surgery"
                                              ? timeObject?.ids?.find(
                                                  (id) =>
                                                    id?.startTime ===
                                                    item?.startTime,
                                                )
                                              : selectTime === item?.startTime
                                          )
                                            ? "bgContainerSelected cursor"
                                            : "bgContainerUnselected cursor"
                                        }
                                      >
                                        {item?.startTime}
                                      </div>
                                    );
                                  })
                                ) : (
                                  <Typography
                                    color="error"
                                    className="ml10 fs14 mtMin10"
                                  >
                                    Slots unavailable. Please update the vets
                                    schedule and continue.
                                  </Typography>
                                )}
                              </div>
                            </div>
                          )}

                        {selectTimeIdError && (
                          <Typography color="error" className="ml20 mt5 fs14">
                            Please select the slot and continue
                            {/* Slots unavailable. Please update the vets schedule
                            and continue. */}
                          </Typography>
                        )}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <CustomTextField
                            name="remarks"
                            fullWidth
                            handleChange={(e) =>
                              onChange(e?.target?.value, "remarks")
                            }
                            value={petValues?.remarks}
                            label="Remarks"
                            multiline
                          />
                        </Grid>
                        <div className="flex1-center mt20">
                          <div>
                            <CustomButton
                              text="Submit"
                              smallBtn
                              onClick={onPreview}
                            />
                          </div>
                        </div>
                      </Grid>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        ) : null}
      </CustomModal>
      <CustomModal
        open={previewModVsble}
        onClose={onClosePreviewMod}
        modalWidth={35}
        modalWoHeader
      >
        <div className="flex-row-ali-cen blu-back ph15 h60">
          <div
            className="br5 flex-center cursor back-btn"
            onClick={onClosePreviewMod}
          >
            <ArrowBackIcon
              sx={{ width: 20, height: 20, color: AppColors.white }}
            />
          </div>

          <Typography className="white-color fs16 font-bold ml15">
            Review
          </Typography>
        </div>
        <div className="scroll-80vh-new">
          <div className="p15">
            <Typography className="fs14 txt-semi-bold blue-color">
              Appointment Details
            </Typography>
            <div className="mt10 gray-brder">
              <div className="gray-brder">
                <div className="flex-row">
                  <div className="w48Per">
                    <div className="flex-row-ali-cen">
                      {selectedPet?.petImage ? (
                        <CardMedia
                          image={selectedPet?.petImage}
                          className="CustomCard-img4-bill"
                        />
                      ) : (
                        <div className="flex-center h40img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {selectedPet?.petName?.[0]}
                          </Typography>
                        </div>
                      )}

                      <div className="flex-column ml10">
                        <div className="flex-row-ali-cen">
                          <Typography className="card-black txt-semi-bold fs12 capitalize">
                            {selectedPet?.petName}
                          </Typography>
                          <Typography
                            className={`ml5 font-medium capitalize fs12 ${
                              selectedPet?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${selectedPet?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="txt-regular card-black1 fs10">
                          {selectedPet?.breed}
                        </Typography>
                      </div>
                    </div>
                    <div className="flex-row-between-align-center mt10">
                      <div className="flex-row-ali-cen">
                        <AccountCircleOutlinedIcon sx={eyeBtn} />
                        <Typography className="txt-semi-bold card-black fs12 capitalize flex-center ml5">
                          {selectedPet?.userName}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <PhoneInTalkIcon sx={eyeBtn} />
                        <Typography className="txt-regular card-black fs12 capitalize flex-center ml5">
                          {selectedPet?.userMobile ?? selectedPet?.mobile}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div className="w4Per flex-center">
                    <div className="gry-ver-split" />
                  </div>
                  <div className="w48Per">
                    <div className="flex-row-ali-cen mt10">
                      <DataUsageIcon sx={eyeBtn} />
                      <Typography className="txt-regular card-black fs12 capitalize flex-center ml5">
                        {getPetAgeDisplay(selectedPet?.dob)} ({selectedPet?.dob}
                        )
                      </Typography>
                    </div>
                    <div className="flex-row-between-align-center mt10">
                      <div className="flex-row-ali-cen w60Per">
                        <ColorLensIcon sx={eyeBtn} />
                        <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                          {selectedPet?.color ?? ""}
                        </Typography>
                      </div>
                      <div className="w40Per flex-end">
                        <div className="flex-row-ali-cen">
                          <ScaleIcon sx={w15h15BlueIcon} />
                          <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                            {selectedPet?.weight?.length > 0
                              ? `${selectedPet?.weight} KG`
                              : ""}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-row-between-align-center mt10">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {moment(
                      new Date(
                        petValues?.appointmentOption === "Immediate"
                          ? new Date()
                          : petValues?.date,
                      ),
                    ).format("DD MMM YYYY")}{" "}
                    |{" "}
                    {petValues?.appointmentOption === "Immediate"
                      ? moment(new Date()).format("HH:mm")
                      : petValues?.serviceType?.value === "Surgery"
                        ? `${timeObject?.ids?.[0]?.startTime} -
                          ${
                            timeObject?.ids?.[timeObject?.ids?.length - 1]
                              ?.startTime
                          }`
                        : selectTime}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Appointment Date & Time
                  </Typography>
                </div>
                <div>
                  <CalendarMonthIcon sx={eyeBtn} />
                </div>
              </div>
              <div className="flex-row-between-align-center mt10">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {petValues?.consultationMode === "Home"
                      ? "Home Visit"
                      : petValues?.consultationMode}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Consultation Mode
                  </Typography>
                </div>
                <div>
                  <AccessTimeIcon sx={eyeBtn} />
                </div>
              </div>
              <div className="flex-row-between-align-center mt10">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {petValues?.visitType?.value}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Visit Type
                  </Typography>
                </div>
                <div>
                  <CalendarMonthIcon sx={eyeBtn} />
                </div>
              </div>
              <div className="gry-hor-split4 mv10" />
              <div className="flex-row-between-align-center">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {petValues?.consultationMode === "Physical" ||
                    petValues?.consultationMode === "Virtual"
                      ? clinicDet?.name
                      : (userDetails?.name ?? selectedPet?.userName)}
                  </Typography>
                  <Typography className="font-medium fs12 black2">
                    {petValues?.consultationMode === "Physical"
                      ? clinicDet?.address
                      : petValues?.consultationMode === "Virtual"
                        ? "Online"
                        : userDetails?.address}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Location
                  </Typography>
                </div>
                <div>
                  <DomainIcon sx={eyeBtn} />
                </div>
              </div>
            </div>

            <Typography className="fs14 txt-semi-bold blue-color mt10">
              Service Details
            </Typography>
            {petValues?.serviceType?.value !== "Consultation" &&
              petValues?.serviceType?.value !== "Surgery" &&
              petValues?.serviceName?.map((ser) => (
                <div className="mt10 apnt-card">
                  <div className="flex-row">
                    <div className="w70Per">
                      <Custom3dotString
                        str={ser?.serviceName}
                        className="fs14 font-bold black30"
                        length={25}
                      />
                    </div>
                    <div className="w30Per">
                      <Typography className="fs14 font-bold red-color">
                        Rs. {ser?.servicePrice}
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row">
                    <div className="w70Per">
                      <Custom3dotString
                        str={ser?.variantName}
                        className="fs12 font-medium gray40"
                        length={25}
                      />
                    </div>
                    <div className="w30Per">
                      {" "}
                      <Typography className="fs12 font-medium gray40">
                        {ser?.estimatedDuration} Mins
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row">
                    <div className="w70Per">
                      <Typography className="fs12 font-medium gray40">
                        {petValues?.serviceType?.value === "Grooming"
                          ? "Groomer"
                          : petValues?.serviceType?.value === "Lab Tests" ||
                              petValues?.serviceType?.value ===
                                "Radiology Tests"
                            ? "Technician"
                            : // : petValues?.serviceType?.value === "Others"
                              // ? "Others"
                              "Vet"}{" "}
                        Name
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="fs12 font-medium gray40">
                        {selectedVet?.name ?? ""}
                      </Typography>
                    </div>
                  </div>
                  {petValues?.assignedUsers?.length > 0 && (
                    <div className="flex-row">
                      <div className="w70Per">
                        <Typography className="fs12 font-medium gray40">
                          Assigned Users
                        </Typography>
                      </div>
                      <div className="w30Per">
                        <Typography className="fs12 font-medium gray40">
                          {getAllClinicUserListWoSelectedVet(
                            selectedVet?.doctorId,
                          )
                            ?.filter((vet) =>
                              petValues?.assignedUsers?.some(
                                (asUr) => asUr?.id === vet?.value,
                              ),
                            )
                            ?.map((vet) => vet?.name)
                            ?.join(", ") || ""}
                        </Typography>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            {(petValues?.serviceType?.value === "Consultation" ||
              petValues?.serviceType?.value === "Surgery") && (
              <div className="mt10 apnt-card">
                <div className="flex-row">
                  <div className="w100Per">
                    <Custom3dotString
                      str={petValues?.serviceType?.value}
                      className="fs14 font-bold black30"
                      length={25}
                    />
                  </div>
                </div>
                {petValues?.serviceType?.value === "Consultation" &&
                  petValues?.reason?.length > 0 && (
                    <div className="flex-row">
                      <div className="w70Per">
                        <Typography className="fs12 font-medium gray40">
                          Reason
                        </Typography>
                      </div>
                      <div className="w30Per">
                        <Typography className="fs12 font-medium gray40">
                          {petValues?.reason?.join(", ")}
                        </Typography>
                      </div>
                    </div>
                  )}
                {/* {petValues?.serviceType?.value === "Surgery" && ( */}
                <div className="flex-row">
                  <div className="w70Per">
                    <Typography className="fs12 font-medium gray40">
                      {/* Facility */}
                      {petValues?.consultationMode === "Home"
                        ? "Kit Name"
                        : "Facility"}
                    </Typography>
                  </div>
                  <div className="w30Per">
                    <Typography className="fs12 font-medium gray40">
                      {petValues?.facility?.name}
                    </Typography>
                  </div>
                </div>
                {/* )} */}
                <div className="flex-row">
                  <div className="w70Per">
                    <Typography className="fs12 font-medium gray40">
                      Vet Name
                    </Typography>
                  </div>
                  <div className="w30Per">
                    <Typography className="fs12 font-medium gray40">
                      {selectedVet?.name ?? ""}
                    </Typography>
                  </div>
                </div>
                {petValues?.assignedUsers?.length > 0 && (
                  <div className="flex-row">
                    <div className="w70Per">
                      <Typography className="fs12 font-medium gray40">
                        Assigned Users
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="fs12 font-medium gray40">
                        {getAllClinicUserListWoSelectedVet(
                          selectedVet?.doctorId,
                        )
                          ?.filter((vet) =>
                            petValues?.assignedUsers?.some(
                              (asUr) => asUr?.id === vet?.value,
                            ),
                          )
                          ?.map((vet) => vet?.name)
                          ?.join(", ") || ""}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            )}
            {petValues?.serviceType?.value === "Others" ? (
              <div>
                <div className="flex-row">
                  <div className="w70Per">
                    <Typography className="fs12 font-medium gray40">
                      Vet Name
                    </Typography>
                  </div>
                  <div className="w30Per">
                    <Typography className="fs12 font-medium gray40">
                      {petValues?.vetName?.name ??
                        `${getRightSaluation(
                          clinicVets,
                          petValues?.vetName?.value,
                        )}${
                          clinicVets?.find(
                            (vt) => vt?.doctorId === petValues?.vetName?.value,
                          )?.name
                        }` ??
                        ""}
                    </Typography>
                  </div>
                </div>
                {petValues?.assignedUsers?.length > 0 && (
                  <div className="flex-row">
                    <div className="w70Per">
                      <Typography className="fs12 font-medium gray40">
                        Assigned Users
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="fs12 font-medium gray40">
                        {getAllClinicUserListWoSelectedVet(
                          petValues?.vetName?.value,
                        )
                          ?.filter((vet) =>
                            petValues?.assignedUsers?.some(
                              (asUr) => asUr?.id === vet?.value,
                            ),
                          )
                          ?.map((vet) => vet?.name)
                          ?.join(", ") || ""}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            <div className="flex-center mt20">
              <div>
                <CustomButton text="Done" onClick={handleSubmit} smallBtn />
              </div>
            </div>
          </div>
        </div>
      </CustomModal>

      {createPetModVsble ? (
        <CreateClinicPet
          createModVisible={createPetModVsble}
          onCloseCreateMod={onCloseCreatePet}
          userDetails={null}
          selectedStep={0}
          showRegisterOnly
        />
      ) : null}
    </>
  );
};

export default VetBookAnAppointment;
